import { pixelToNumber } from 'ComponentLibrary/src/common/numbers'
import { tokens } from 'ComponentLibrary/style-dictionary/output'
import type { AxisTickProps } from '@nivo/axes'

export const ComparisonChartTick = ({ x, y, value, format }: AxisTickProps<number>) => (
    <text
        className="tick"
        textAnchor="middle"
        dominantBaseline="text-after-edge"
        transform={`translate(${x}, ${y - pixelToNumber(tokens.SizingSpacing075)})`}
        fontSize={tokens.FontSizeXs}
    >
        {format?.(value)}
    </text>
)
